/* Qalbeen · HOVER : petit « i » après chaque « Qalbeen+ » du site (snippets/hover-qplus.liquid, 17/10/2026).
   Pas dans les liens, boutons, champs ni le texte réservé aux lecteurs d'écran ; un seul « i » par élément.
   Le contenu ajouté plus tard (panier, onglets…) est relu par un MutationObserver. */
(function () {
  var D = document, dlg = D.getElementById('hv-qp');
  if (!dlg) return;
  var MOT = 'Qalbeen+';
  var SKIP = 'a,button,select,option,textarea,input,label.hv-sr,.hv-sr,script,style,noscript,dialog,svg,title,[data-no-qp],[contenteditable],.visually-hidden';

  function bouton() {
    var b = D.createElement('button');
    b.type = 'button'; b.className = 'hv-qp-i'; b.setAttribute('aria-haspopup', 'dialog');
    b.setAttribute('aria-label', 'Qu’est-ce que Qalbeen+ ?');
    b.innerHTML = '<span aria-hidden="true">i</span>';
    return b;
  }

  function relire(root) {
    var base = root && root.nodeType === 3 ? root.parentNode : root;
    if (!base || base.nodeType !== 1) return;
    var w = D.createTreeWalker(base, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeValue.indexOf(MOT) > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    var liste = [], n;
    while ((n = w.nextNode())) liste.push(n);
    liste.forEach(function (t) {
      var el = t.parentElement;
      if (!el || el.closest(SKIP) || el.querySelector(':scope > .hv-qp-i')) return;
      var i = t.nodeValue.indexOf(MOT) + MOT.length, reste = t.splitText(i);
      el.insertBefore(bouton(), reste);
    });
  }

  function ouvrir(e) {
    e.preventDefault(); e.stopPropagation();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function fermer() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }

  D.addEventListener('click', function (e) {
    if (e.target.closest('.hv-qp-i')) return ouvrir(e);
    if (e.target === dlg || e.target.closest('[data-hv-qp-x]')) { e.preventDefault(); fermer(); }
  }, true);

  function go() {
    relire(D.body);
    var file = [], t = 0;
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1 || x.nodeType === 3) file.push(x); }); });
      if (file.length && !t) t = setTimeout(function () { var f = file; file = []; t = 0; f.forEach(function (x) { if (x.isConnected) relire(x); }); }, 250);
    }).observe(D.body, { childList: true, subtree: true });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', go); else go();
})();
